// Navigation skeleton, all planned modules.
// Each entry routes to /app/<key>; modules not yet built render ComingSoon.
import {
    LayoutDashboard,
    Sparkles,
    Radar,
    Gavel,
    ShieldCheck,
    Scale,
    GitCompareArrows,
    BellRing,
    Cpu,
    Lock,
    Banknote,
    Network,
    Newspaper,
    Tag,
    UserCircle,
    Feather,
    Users,
} from "lucide-react";

export const NAV_GROUPS = [
    {
        label: "Workspace",
        items: [
            { key: "dashboard", label: "Dashboard", to: "/app", icon: LayoutDashboard, ready: true },
            { key: "research", label: "Research Assistant", to: "/app/research", icon: Sparkles, ready: true },
            { key: "regulatory", label: "Regulatory Intelligence", to: "/app/regulatory", icon: Radar, ready: true },
            { key: "case-law", label: "Case Law Explorer", to: "/app/case-law", icon: Gavel, ready: true },
            { key: "compliance", label: "Compliance Checker", to: "/app/compliance", icon: ShieldCheck, ready: true },
            { key: "treaty", label: "Treaty Explorer", to: "/app/treaty", icon: Scale, ready: true },
            { key: "comparative", label: "Comparative Law", to: "/app/comparative", icon: GitCompareArrows, ready: true },
            { key: "argument", label: "Argument Generator", to: "/app/argument", icon: Feather, ready: true },
            { key: "watchdogs", label: "Watchdogs & Alerts", to: "/app/watchdogs", icon: BellRing, ready: true },
        ],
    },
    {
        label: "Compliance Modules",
        items: [
            { key: "ai-act", label: "AI Act", to: "/app/ai-act", icon: Cpu, ready: true },
            { key: "gdpr", label: "GDPR", to: "/app/gdpr", icon: Lock, ready: true },
            { key: "dora", label: "DORA", to: "/app/dora", icon: Banknote, ready: true },
            { key: "nis2", label: "NIS2", to: "/app/nis2", icon: Network, ready: true },
        ],
    },
    {
        label: "Library",
        items: [
            { key: "bulletins", label: "Bulletins", to: "/app/bulletins", icon: Newspaper, ready: true },
            { key: "team", label: "Team", to: "/app/team", icon: Users, ready: true },
            { key: "pricing", label: "Pricing", to: "/app/pricing", icon: Tag, ready: true },
            { key: "profile", label: "Profile", to: "/app/profile", icon: UserCircle, ready: true },
        ],
    },
];

export const FLAT_NAV = NAV_GROUPS.flatMap((g) => g.items);

export const MOBILE_PRIMARY = [
    { key: "dashboard", label: "Home", to: "/app", icon: LayoutDashboard },
    { key: "research", label: "Research", to: "/app/research", icon: Sparkles },
    { key: "regulatory", label: "Reg.", to: "/app/regulatory", icon: Radar },
    { key: "watchdogs", label: "Alerts", to: "/app/watchdogs", icon: BellRing },
    { key: "profile", label: "Profile", to: "/app/profile", icon: UserCircle },
];
